module.exports = __webpack_public_path__ + "static/media/waveheadercontent.0ebbb76f.png";